import { render } from "./CorrelationComposition.vue?vue&type=template&id=c8494302"
import script from "./CorrelationComposition.vue?vue&type=script&lang=js"
export * from "./CorrelationComposition.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__